module.exports = __webpack_public_path__ + "static/media/lock-closed.63b193cf.svg";